<!-- 用户管理 -->
<template>
  <div class="diseaseList">
    <!-- 封装selectForm筛选 -->
    <el-form :inline="true">
      <el-button type="primary" size="small" v-waves @click="handleAdd">新增</el-button>
      <el-form-item label="账号: " style="margin: 0 12px 0" size="small">
        <el-input v-model="listQuery.username" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="手机号: " style="margin: 0 12px 0 0" size="small">
        <el-input v-model="listQuery.phone_number" placeholder="请输入" clearable type="number"></el-input>
      </el-form-item>
      <el-form-item label="账号类型:" style="margin: 0 12px 0 0" size="small">
        <el-select v-model="listQuery.grade" placeholder="请选择" style="width: 100%" clearable>
          <div v-for="(item, index) in gradeList" :key="index">
            <el-option :label="item.name" :value="item.id"></el-option>
          </div>
        </el-select>
      </el-form-item>
      <el-form-item label="创建人账号: " style="margin: 0 12px 0 0" size="small">
        <el-input v-model="listQuery.createUserName" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-button type="primary" @click="search" size="small" v-waves style="margin: 0 0px 10px 0">搜索</el-button>
    </el-form>

    <div class="tableList">
      <!-- 封装表单table组件 -->
      <ElTable :columns="listHeader" :tableData="tableData" :loading="loading" :total="listQuery.total"
        @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange">
        <!-- <template slot="parent_id" slot-scope="{ row }">
          <p v-if="!row.parent_id">
            —
          </p>
          <el-tag effect="dark" size="mini" v-else>
            所属上级{{ row.parent_id }}
          </el-tag>
        </template>
<template slot="store_id" slot-scope="{ row }">
          <p v-if="!row.store_id">
            —
          </p>
          <el-tag type="success" effect="dark" size="mini" v-else>
            <StoreToString :store_id="row.store_id" />
          </el-tag>
        </template> -->

        <template slot="title" slot-scope="{ row }">
          <el-tag type="success" effect="dark" size="mini">
            {{ row.title }}
          </el-tag>
        </template>

        <template slot="id" slot-scope="{ row }">
          <el-tag effect="dark" size="mini">
            {{ row.id }}
          </el-tag>
        </template>


        <template slot="discount" slot-scope="{ row }">
          <div v-if="row.grade == 3">享受其主账号同等折扣</div>
          <div v-else-if="row.grade == 1">-</div>
          <div v-else-if="!row.discount">暂未设置</div>
          <el-tag type="success" effect="dark" size="mini" v-else>
            {{ row.discount }}
          </el-tag>
        </template>

        <template slot="createUserName" slot-scope="{ row }">
          <div v-if="row.createUserName"> {{ row.createUserName }}</div>
          <div v-else>-</div>
        </template>


        <template slot="error" slot-scope="{ row }">
          <el-tag type="success" effect="dark" size="mini" v-if="!row.error">
            无异常
          </el-tag>
          <el-tag type="danger" effect="dark" size="mini" v-else>
            {{ row.error }}次
          </el-tag>
        </template>

        <template slot="status" slot-scope="{ row }">
          <el-tag type="success" effect="dark" size="mini" v-if="row.status == 1">
            正常
          </el-tag>
          <el-tag type="danger" effect="dark" size="mini" v-else>
            暂停使用
          </el-tag>
        </template>
        <template slot="operation" slot-scope="{ row }">
          <div class="operation">
            <!-- <el-button size="mini" type="text" @click="handleRole(row)" primary
              >设置权限</el-button
            > -->
            <el-button size="mini" type="text" @click="handleEdit(row)" primary
              :disabled="userInfo.authGroupId !== 1">编辑</el-button>
            <el-button size="mini" type="text" style="color: rgb(255, 0, 0)" @click="handleDelete(row)"
              v-if="row.id !== 1" :disabled="userInfo.authGroupId !== 1">删除</el-button>
            <!-- <el-button size="mini" type="text" @click="handleRole(row)" primary
              v-if="row.id!=1"
              >查看名下子账号</el-button
            > -->
          </div>
        </template>
      </ElTable>
    </div>
    <!-- 表单弹窗 -->
    <el-dialog :title="dialogName" :visible.sync="dialogVisible" :close-on-click-modal="false">
      <el-form ref="form" :model="dialogForm" label-width="90px">
        <el-form-item label="账号状态:" required>
          <el-select v-model="dialogForm.status" placeholder="请选择" style="width: 100%"
            :disabled="!dialogForm.createID && dialogForm.id">
            <div v-for="(item, index) in statusList" :key="index">
              <el-option :label="item.name" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="账号角色:" required>
          <el-input clearable v-model="dialogForm.title" placeholder="请输入"
            v-if="dialogForm.createID != userInfo.id && dialogForm.id" disabled></el-input>
          <el-select v-model="dialogForm.authGroupId" placeholder="请选择" style="width: 100%" clearable v-else>
            <div v-for="(item, index) in authGroupList" :key="index">
              <el-option :label="item.title" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="账号" required>
          <el-input clearable v-model="dialogForm.username" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="密码" required>
          <el-input clearable v-model="dialogForm.password" placeholder="输入密码保存后自动md5加密"></el-input>
        </el-form-item>

        <el-form-item label="昵称" required>
          <el-input clearable v-model="dialogForm.alias_name"></el-input>
          <!-- <el-input type="textarea" clearable v-model="dialogForm.alias_name"></el-input> -->
        </el-form-item>

        <el-form-item label="手机号" required>
          <el-input clearable v-model="dialogForm.phone_number"></el-input>
        </el-form-item>

        <!-- <el-form-item label="账号折扣" v-if="dialogForm.grade != 1">
          <el-input clearable v-model.number="dialogForm.discount" placeholder="输入折扣数字，如：0.7（表示7折），便于发起订单时系统自动计算折扣"
            type="number" v-if="dialogForm.grade == 2 || !dialogForm.id"></el-input>
          <el-input clearable v-model.number="dialogForm.discount" placeholder="享受其主账号同等折扣" disabled
            v-if="dialogForm.grade == 3"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="微信绑定">
          <el-input clearable v-model="dialogForm.openid" placeholder="请输入openid"></el-input>
        </el-form-item> -->


        <el-form-item label="异常登录" required v-if="dialogName !== '创建账号'">
          <el-input clearable v-model.number="dialogForm.error" placeholder="超过5次账号冻结,默认为0" type="number"></el-input>
        </el-form-item>

        <el-form-item label="最近登录">
          <el-input clearable v-model="dialogForm.update_time" placeholder="暂未登录" disabled></el-input>
        </el-form-item>


        <!-- <el-form-item label="分配门店:">
          <el-select
            v-model="dialogForm.store_id"
            placeholder="请选择"
            style="width: 100%"
            clearable
            multiple
            filterable
          >
            <div v-for="(item, index) in storeList" :key="index">
              <el-option
                :label="item.store_name"
                :value="item.store_id + ''"
              ></el-option>
            </div>
          </el-select>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ElTable from "@/components/elTable/index.vue";
import listHeader from "./listHeader";
import filterQueryFormItems from "./filterQueryFormItems";
import Percentage from "@/components/filters/Percentage.vue";
import FillingStatus from "@/components/filters/FillingStatus.vue";
import KindTab from "@/components/tab/kindTab/index.vue";
import StoreToString from "@/components/filters/storeToString.vue";
import { mapState } from "vuex";
import {
  selectAdmin,
  deleteAdmin,
  updateAdmin,
  addAdminManual,
  updateRole,
  selectAuthGroup,
} from "@/services/system/user.js";
import { selectStore } from "@/services/mall/store";
// import md5 from "md5";
export default {
  components: {
    ElTable,
    Percentage,
    FillingStatus,
    KindTab,
    StoreToString,
  },
  // directives: {
  //   waves,
  // },
  created() {
    //根据权限初始化导航
    this.getListData();
    this.getGroup();
  },
  data() {
    return {
      loading: false,
      listQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
      },
      /* 表格数据 */
      tableData: [],
      statusList: [
        { id: 1, name: "正常" },
        { id: 2, name: "暂停使用" },
      ],
      storeList: [],
      authGroupList: [], //权限组
      /* 弹窗 */
      dialogName: "",
      dialogVisible: false,
      dialogForm: {},
      password: "",
      gradeList: [
        { id: 1, name: "超级管理员" },
        { id: 2, name: "二级账号(内部员工，医院主账号)" },
        { id: 3, name: "三级账号(医院子账号)" },
      ],
      navData: [],
      checkedData: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
    };
  },
  computed: {
    filterQueryFormItems,
    listHeader,
    ...mapState(["userInfo"]),
  },

  watch: {},
  methods: {
    /* 所以门店数据 */
    async getStoreData() {
      const { data, code } = await selectStore({
        pageNumber: 1,
        pageSize: 1000,
      });
      if (code === 200) {
        this.storeList = data;
      }
    },
    getGroup() {
      selectAuthGroup({ createID: this.userInfo.id }).then((res) => {
        if (res.code === 200) {
          this.authGroupList = res.data;
        }
      });
    },

    async getListData() {
      this.loading = true;
      // this.listQuery.createID = this.userInfo.id;
      const { data, code, count } = await selectAdmin(this.listQuery);
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 200);
      }
    },
    /* 搜索按钮 */
    async search(listQuery) {
      this.getListData();
    },
    /* 分页 */
    handleCurrentChange(e) {
      console.log(e);
      this.listQuery.pageNumber = e;
      this.getListData();
    },
    handleSizeChange(e) {
      console.log(e);
      this.listQuery.pageSize = e;
      this.getListData();
    },

    /* 新增 */
    handleAdd() {
      this.getStoreData();
      this.dialogVisible = true;
      this.dialogName = "创建账号";
      this.dialogForm = {
        error: 0,
      };
      this.password = "";
    },

    /* 修改 */
    handleEdit(row) {
      this.getStoreData();
      this.dialogVisible = true;
      this.dialogName = "编辑账号";
      this.password = row.password;
      this.dialogForm = JSON.parse(JSON.stringify(row));
      this.dialogForm.store_id = this.dialogForm.store_id?.split(",") || [];
    },


    save() {

      if (
        !this.dialogForm.authGroupId ||
        !this.dialogForm.username ||
        !this.dialogForm.password ||
        !this.dialogForm.alias_name ||
        (!this.dialogForm.error && this.dialogForm.error !== 0)
      ) {
        this.$message.error("请填写必填字段");
        return;
      }
      /* 账号格式校验 */
      let reg_tel =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (!reg_tel.test(this.dialogForm.phone_number)) {
        this.$message.error("手机号格式错误");
        return;
      }

      if (this.dialogName === "创建账号") {
        addAdminManual({
          ...this.dialogForm,
          grade: 2,
          createID: this.userInfo.id,
          // store_id: this.dialogForm.store_id
          //   ? this.dialogForm.store_id?.join(",")
          //   : null,
        }).then((res) => {
          if (res.code === 200) {
            this.listQuery.pageNumber = 1;
            this.getListData();
            this.$message({
              type: "success",
              message: "创建成功!",
            });
            this.dialogVisible = false;
          }
        });
      }
      if (this.dialogName === "编辑账号") {
        updateAdmin({
          ...this.dialogForm,
          password: this.dialogForm.password,
          // store_id: this.dialogForm.store_id
          //   ? this.dialogForm.store_id?.join(",")
          //   : null,
        }).then((res) => {
          console.log("编辑账号", res);
          if (res.code === 200) {
            this.getListData();
            this.$message({
              type: "success",
              message: "编辑成功!",
            });
            this.dialogVisible = false;
          }
        });
      }
    },

    /* 删除 */
    handleDelete(row) {
      console.log(row.id);
      this.$confirm("此操作将永久删除该账号, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log(row.id);
          deleteAdmin({ id: row.id }).then((res) => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getListData();
          });
        })
        .catch(() => { });
    },
  },
};
</script>

<style scoped lang="less">
.diseaseList {
  width: 100%;
}

.selectForm {
  background: #fff;
  // max-width: 1405px;
  padding: 10px 0;
  margin: 10px auto;
}

.tableList {
  border-radius: 6px;
  background: #fff;
  // max-width: 1405px;
  margin: 10px auto;
}

.operation {
  a {
    margin-right: 10px;
  }
}
</style>
